import { authRoles } from 'app/auth';
import React from 'react';

const TermsPage = {
  settings: {
    layout: {
      config: {}
    }
  },
  // auth: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  //  empty[] permet la page d'être visible quand pas connecté
  // auth: [],
  routes: [
    {
      path: '/terms',
      exact: true,
      component: React.lazy(() => import('./TermsPage'))
    }
  ]
};

const TermsPageLogin = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/conditions',
      exact: true,
      component: React.lazy(() => import('./TermsPage'))
    }
  ]
};

const PrivacyPolicy = {
  settings: {
    layout: {
      config: {}
    }
  },
  // auth: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  //  empty[] permet la page d'être visible quand pas connecté
  // auth: [],
  routes: [
    {
      path: '/privacy-policy',
      exact: true,
      component: React.lazy(() => import('./PrivacyPolicy'))
    }
  ]
};

const PrivacyPolicyLogin = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/privacy-policy-login',
      exact: true,
      component: React.lazy(() => import('./PrivacyPolicy'))
    }
  ]
};

const CookiesPolicy = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/cookies-policy',
      exact: true,
      component: React.lazy(() => import('./CookiesPolicy'))
    }
  ]
};

const CookiesPolicyLogin = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/cookies-policy-login',
      exact: true,
      component: React.lazy(() => import('./CookiesPolicy'))
    }
  ]
};

export { TermsPage, TermsPageLogin, PrivacyPolicy, PrivacyPolicyLogin, CookiesPolicyLogin, CookiesPolicy };
